import { Section_SharedTo as Section } from 'views/index';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { removeSharedObject } from '../flow/actions';

const defaultProps = {};
const propTypes = {
  selectedData: PropTypes.array.isRequired
};

class SharedTo extends Component {
  componentDidMount() {}

  handleTagRemove = (id, type) => this.props.removeSharedObject(id, type);
  handleSharedDataChange = () => {};

  render() {
    const { selectedData } = this.props;
    return (
      <Section
        selectedData={selectedData}
        onTagRemove={this.handleTagRemove}
        onSharedDataChange={this.handleSharedDataChange}
      />
    );
  }
}

// utils
const filterSelectedData = (data, selectedIds) =>
  data.filter(obj => selectedIds.indexOf(obj.id) > -1);

const mapStateToProps = ({ reportList, sharableObjects }) => {
  const { dashboard, report } = reportList.folders;
  const activeFolder = [...dashboard, ...report].find(f => f.isActive);

  const sharedToUsers = activeFolder
    ? activeFolder.sharedToUsers.map(u => u.id)
    : [];
  const sharedToTeams = activeFolder
    ? activeFolder.sharedToTeams.map(t => t.id)
    : [];

  const { users, flatTeams } = sharableObjects;
  const selectedUsers = filterSelectedData(users, sharedToUsers);
  const selectedTeams = filterSelectedData(flatTeams, sharedToTeams);

  // Combine selected users and teams, format record to cater for "Section" requirements
  const selectedData = [...selectedUsers, ...selectedTeams].map(obj => ({
    key: `${obj.type}_${obj.id}`,
    id: obj.id,
    name: obj.name,
    type: obj.type,
    icon: obj.type === 'team' ? 'team' : 'user'
  }));

  return {
    activeFolder,
    selectedData
  };
};
const mapDispatchToProps = {
  removeSharedObject
};
SharedTo.defaultProps = defaultProps;
SharedTo.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SharedTo);



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/components/SharedTo.jsx